import "./WhatIDoOne.scss";

function WhatIDoOne() {
  return (
    <div className="WhatIDoOne">
      <div className="title">
        <h1>What I Do?</h1>
      </div>
      <div className="body">
        <div className="left">
          <img src="assets/AndroidDeveloper.svg" alt="" Android Vector Image />
        </div>
        <div className="right">
          <h2>Mobile Application Development</h2>
          <div className="technoloy">
            <div className="item">
              <img src="assets/Javascript.png" alt="" />
              <p className="tech-title">Javascript</p>
            </div>
            <div className="item">
              <img src="assets/Kotlin.png" alt="" />
              <p className="tech-title">Kotlin</p>
            </div>
            <div className="item">
              <img src="assets/React-Native.png" alt="" />
              <p className="tech-title">React Native </p>
            </div>
            <div className="item">
              <img src="assets/Flutter.png" alt="" />
              <p className="tech-title">Flutter</p>
            </div>
            <div className="item">
              <img src="assets/Android.png" alt="" />
              <p className="tech-title">Android</p>
            </div>
          </div>
          <div className="desc">
            <p>
              ⚡ Android developer responsible for full app life-cycle: concept, design, build, test, deploy and release to the app store.
            </p>
            <br />
            <p>
              ⚡ Written unit test cases across multiple browsers, platforms, and devices, including.
            </p>
            <br />
            <p>
              ⚡ Building React native application utilizing Redux for enhanced maintainability.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatIDoOne;
